import type { HexMapState } from '../engine/render/renderer';
import { addInventory, addTools, removeInventory, takeTools } from '../engine/settlement';

export function runTransportTick(state: HexMapState): boolean {
    let changed = false;
    const config = state.config.transport;
    state.transportRoutes.forEach((route) => {
        if (route.status === 'traveling') {
            route.progress += 1;
            if (route.progress < route.totalTicks) return;
            route.progress = 0;
            route.status = 'cooldown';
            route.cooldownLeft = route.cooldownTicks;
            route.lastArrivedAt = state.simulation.tick;
            const target = state.settlementsById[route.toSettlementId];
            if (!target) return;
            if (route.resource === 'tools') {
                addTools(target, route.cargoTools || []);
                route.cargoTools = [];
            } else {
                addInventory(target, route.resource, route.cargoAmount);
            }
            route.cargoAmount = 0;
            changed = true;
            return;
        }

        if (route.status === 'cooldown') {
            if (route.cooldownLeft > 0) {
                route.cooldownLeft -= 1;
                return;
            }
            route.status = 'idle';
            return;
        }

        const source = state.settlementsById[route.fromSettlementId];
        const target = state.settlementsById[route.toSettlementId];
        if (!source || !target) return;
        if (route.resource === 'tools') {
            const available = source.inventory.tools.length;
            if (available < route.amount) return;
            route.cargoTools = takeTools(source, route.amount);
            route.cargoAmount = route.cargoTools.length;
        } else {
            const available = source.inventory[route.resource] ?? 0;
            if (available < route.amount) return;
            const removed = removeInventory(source, route.resource, route.amount);
            route.cargoAmount = removed;
        }
        if (route.cargoAmount <= 0) return;
        route.status = 'traveling';
        route.progress = 0;
        route.totalTicks = Math.max(
            1,
            Math.round(config.baseTicks + route.distance * config.ticksPerHex),
        );
        route.lastDepartedAt = state.simulation.tick;
        changed = true;
    });

    return changed;
}
